import React from 'react';
import { ATMDropdown } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { IProps } from './dropdown-employee.component';

const DropdownEmployeeView: React.FC<IProps> = (props) => (
  <ATMDropdown
    fluid
    selection
    search={(options) => options}
    placeholder={Lang.LBL_SEARCH}
    {...props}
  />
);

export default DropdownEmployeeView;
